import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseContract } from './base';

export class ApiContractVolume extends ApiBaseContract {
  @ApiOptions({ channel: 'userCurves.series.gas.get', interceptErrors: false })
  getGasUserCurvesSeries(params: ParamsAdapter) {
    return this.get(`/volume/series/gas/user-curves/values/v2`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.power.get', interceptErrors: false })
  getPowerUserCurvesSeries(params: ParamsAdapter) {
    return this.get(`/volume/series/power/user-curves/values/v2`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.power.post' })
  postPowerUserCurvesSeries(params: ParamsAdapter) {
    return this.post(`/volume/series/power/user-curves/values`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.gas.post' })
  postGasUserCurvesSeries(params: ParamsAdapter) {
    return this.post(`/volume/series/gas/user-curves/values`, params);
  }

  @ApiOptions({ channel: 'volumeExportExcel', responseType: 'blob', interceptRedirection: true })
  getGasExcelSync(params: ParamsAdapter) {
    return this.get<Blob>(`/volume/series/gas/user-curves/download-excel`, params);
  }

  @ApiOptions({ channel: 'volumeExportExcel', responseType: 'blob', interceptRedirection: true })
  getPowerExcelSync(params: ParamsAdapter) {
    return this.get<Blob>(`/volume/series/power/user-curves/download-excel`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.download', responseType: 'blob', responseObserve: 'response' })
  downloadUserCurvesSeries(commodity: string, params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>(`/volume/series/${commodity}/user-curves/download-excel`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.gas.get' })
  getGasUserCurvesSummaries(params: ParamsAdapter) {
    return this.get(`/volume/series/gas/user-curves`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.power.get' })
  getPowerUserCurvesSummaries(params: ParamsAdapter) {
    return this.get(`/volume/series/power/user-curves`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.gas.delete' })
  deleteGasUserCurveSummary(params: ParamsAdapter) {
    return this.delete(`/volume/series/gas/user-curves`, params, false);
  }

  @ApiOptions({ channel: 'userCurves.series.power.delete' })
  deletePowerUserCurveSummary(params: ParamsAdapter) {
    return this.delete(`/volume/series/power/user-curves`, params, false);
  }

  @ApiOptions({ channel: 'userCurves.series.power.post', interceptErrors: false })
  postPowerUserCurvesSummary(params: ParamsAdapter) {
    return this.post(`/volume/series/power/user-curves`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.gas.post', interceptErrors: false })
  postGasUserCurvesSummary(params: ParamsAdapter) {
    return this.post(`/volume/series/gas/user-curves`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.power.get' })
  getAggregatedPowerUserCurves(params: ParamsAdapter) {
    return this.get(`/volume/power/view`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.gas.get' })
  getAggregatedGasUserCurves(params: ParamsAdapter) {
    return this.get(`/volume/gas/view`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.upload', interceptErrors: false })
  uploadGasUserCurvesSeries(params: ParamsAdapter) {
    return this.post(`/volume/series/gas/user-curves/upload-excel`, params);
  }

  @ApiOptions({ channel: 'userCurves.series.upload', interceptErrors: false })
  uploadPowerUserCurvesSeries(params: ParamsAdapter) {
    return this.post(`/volume/series/power/user-curves/upload-excel`, params);
  }
}
